import { render } from "./NavigationSettings.vue?vue&type=template&id=41c69d1a"
import script from "./NavigationSettings.vue?vue&type=script&lang=js"
export * from "./NavigationSettings.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__